import type { ProjectReference } from '@indutrust/factory-model';
import { createCrudEvents } from '@indutrust/shared-util';

/**
 * Standard CRUD events for a factory's project references collection.
 *
 * Backed by {@link import('../factory-project-reference-api-client.service').FactoryProjectReferenceApiClient}
 * at `/factories/{factoryId}/project_references`. Dispatchers must
 * always pass `urlSegments: { factoryId }` so the request resolves
 * the parent factory.
 *
 * Source namespace: `factory.project-reference` — keeps the Redux
 * DevTools trace grouped with the other factory sub-resources.
 *
 * @example
 * const dispatch = injectDispatch(factoryProjectReferenceCrudEvents);
 * dispatch.loadAllRequested({ urlSegments: { factoryId: 7 } });
 */
export const factoryProjectReferenceCrudEvents =
  createCrudEvents<ProjectReference>('factory.project-reference');
